// extracted by mini-css-extract-plugin
export var whyitsm__grid = "whyitsm-module--whyitsm__grid--VrGqm";
export var whyitsm__title = "whyitsm-module--whyitsm__title--1ZghK";
export var whyitsm__desc = "whyitsm-module--whyitsm__desc--dXFjQ";
export var whyitsm__item = "whyitsm-module--whyitsm__item--8cq2R";
export var whyitsm__itemHeader = "whyitsm-module--whyitsm__itemHeader--6Ijwb";
export var whyitsm__itemIcon = "whyitsm-module--whyitsm__itemIcon--4NX29";
export var whyitsm__itemIconWrapper = "whyitsm-module--whyitsm__itemIconWrapper--P1wE9";
export var whyitsm__itemTitle = "whyitsm-module--whyitsm__itemTitle--Ocqek";
export var whyitsm__itemDesc = "whyitsm-module--whyitsm__itemDesc--snsF1";
export var whyitsm__image = "whyitsm-module--whyitsm__image--gPous";
export var whyitsm__imageWrapper = "whyitsm-module--whyitsm__imageWrapper--SkRVT";
export var whyitsm__imageImage = "whyitsm-module--whyitsm__imageImage--juNUl";